import { getDrawDates } from '@lotta/shared/util-draws';
import { DateTime } from 'luxon';
import type { Control } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { DrawDatesTable } from '../../../components/draw-dates-table/DrawDatesTable';
import type { WeeklyOccurrenceFormType } from '../WeeklyOccurrenceForm';
import { toPayload } from '../to-payload';

export const WeeklyDrawDaysPreview: React.FC<{
  control: Control<WeeklyOccurrenceFormType>;
  timezone: string;
}> = ({ control, timezone }) => {
  const startDate = useWatch({ control, name: 'startDate' });
  const numberOfWeeks = useWatch({ control, name: 'numberOfWeeks' });
  const drawDay = useWatch({ control, name: 'drawDay' });
  const drawTime = useWatch({ control, name: 'drawTime' });

  const parsedStartDate = DateTime.fromISO(startDate, { zone: timezone });

  if (
    !parsedStartDate.isValid ||
    numberOfWeeks < 1 ||
    drawDay > 7 ||
    drawDay < 1 ||
    drawTime === ''
  ) {
    return null;
  }

  // Convert the user input to lottery schema format
  const { lottery } = toPayload({ startDate, numberOfWeeks, drawDay, drawTime });

  const drawDates = getDrawDates(lottery, timezone);

  return <DrawDatesTable data={drawDates} />;
};
